import { fetcher } from "helpers/fetcher";

import {
  TGetCorporationGlobalListReq,
  TGetCorporationGlobalListRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCorporationGlobalList = async (
  payload?: TGetCorporationGlobalListReq,
  language?: string
) => {
  return await fetcher<
    TGetCorporationGlobalListRes,
    TGetCorporationGlobalListReq
  >(ENDPOINT.CORPORATION.GET_CORP_GLOBAL_LIST, {
    data: payload,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.CORPORATION.GET_CORP_GLOBAL_LIST.version,
      [API_HEADER.LANGUAGE]: language,
    },
  });
};

export const queryGetCorporationGlobalList = async (
  params?: TGetCorporationGlobalListReq
) => {
  return (await getCorporationGlobalList(params)).data;
};

queryGetCorporationGlobalList._key = (
  params?: TGetCorporationGlobalListReq
) => [ENDPOINT.CORPORATION.GET_CORP_GLOBAL_LIST.url, params];
